export const REORDER_APP_VIEWS = {
  CTA: "CTA",
  LIST: "List",
} as const;
